import { useEffect, useState } from "react";
import classes from "./OfflineGuard.module.css";

export default function OfflineGuard({ children }) {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  if (isOnline) return children;

  return (
    <div className={classes.container}>
      <div className={classes.illustration}>
        <svg viewBox="0 0 80 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Wifi arcs — faded */}
          <path d="M10 28 Q40 4 70 28" stroke="rgba(255,255,255,0.15)" strokeWidth="4" strokeLinecap="round" fill="none"/>
          <path d="M18 36 Q40 18 62 36" stroke="rgba(255,255,255,0.15)" strokeWidth="4" strokeLinecap="round" fill="none"/>
          <path d="M26 44 Q40 32 54 44" stroke="rgba(255,255,255,0.15)" strokeWidth="4" strokeLinecap="round" fill="none"/>
          {/* Dot */}
          <circle cx="40" cy="53" r="3.5" fill="rgba(255,255,255,0.15)"/>
          {/* Slash */}
          <line x1="18" y1="10" x2="62" y2="54" stroke="#be8b1a" strokeWidth="3.5" strokeLinecap="round"/>
        </svg>
      </div>

      <div className={classes.textBlock}>
        <h1 className={classes.title}>No Internet Connection</h1>
        <p className={classes.subtitle}>
          Check your Wi-Fi or mobile data and try again.
        </p>
      </div>

      <button className={classes.retryBtn} onClick={() => window.location.reload()}>
        Try Again
      </button>
    </div>
  );
}
